module.exports = __webpack_public_path__ + "img/08.55c5621a.jpg";